export const stateSelector = state => state.state;

export const availableStatesSelector = state => state.profile.profile;

export const selectStatePayers = state => state.state.payers;

export const selectStatePayer = state => state.state.selectedPayer;

export const selectCpts = state => state.state.cpts;
